import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {
  if(!data[key]) return;
  
  const getText = () =>{
    switch(data[key]) {
      case '1':
        return 'Draft';
      case '2':
        return 'Moderation pending';
      case '3':
        return 'Rejected';
      case '4':
        return 'Ready';
      case '6':
        return 'Working';
      case '7':
        return 'Paused';
      case '8':
        return 'Stopped';
      case '9':
        return 'Completed';
    }
  }
  
  const getColor = () =>{
    switch(data[key]) {
      case '1':
        return 'gray';
      case '2':
        return '#0080ff';
      case '3':
        return '#ee2b2b';
      case '4':
        return '#00b359';
      case '6':
        return '#00b359';
      case '7':
        return '#fa0';
      case '8':
        return '#fa0';
      case '9':
        return '#fa0';
    }
  }

  component.tag = 'span';
  
  if(data['DT_RowIntegrationStatus'] !== 'active'){
    return vtag('span', {style: {}},ctx.t('Not active'))
  }
  
  return vtag('div', {style: {}},
    [vtag(
      'span',
      {style: {'color': getColor()}},
      [
        vtag('ui-icon', {
          class: 'mr-4',
          style: {
            ...(!ctx.$PL['integrationPropellerads'] ? {opacity: 0.5} : {})
          },
          props: {
            icon: 'fas fa-circle', 
            size: '12', 
            color:getColor()
          }
        }),
        vtag('span', {
          style: {
            ...(!ctx.$PL['integrationPropellerads'] ? {opacity: 0.5} : {})
          }
        },
        [
          getText(),
          vtag('ui-tooltip-icon', {
            class: 'ml-4',
            props: {
              preset: 'help',
            }
          },ctx.t('To update the statuses BeMob is synced with the source every 5 min.'))]
        ),
      ]
    )]
  );
}
